import { inject, injectable } from "inversify";
import { TYPES } from "@utils/inversifyJS/types";
import type { IRawFileRepository, RawFileUsage } from "@domain/repositories/IRawFileRepository";

/**
 * Deletion of raw files and folders, plus the usage lookup that must precede a file deletion.
 *
 * Deleting is irreversible and the backend keeps no referential integrity between raw files and the jobs that
 * consumed them. For files, callers run `getUsageAsync` first and surface any referencing jobs. For folders no
 * usage lookup is performed, so callers must warn unconditionally instead.
 */
@injectable()
class DeleteRawFileService {
  @inject(TYPES.IRawFileRepository)
  private _rawFileRepository!: IRawFileRepository;

  async getUsageAsync(fileName: string, folder?: string): Promise<RawFileUsage> {
    return this._rawFileRepository.getRawFileUsage(fileName, folder);
  }

  async executeAsync(fileName: string, folder?: string, isFolder?: boolean): Promise<boolean> {
    return this._rawFileRepository.deleteRawFile(fileName, folder, isFolder);
  }
}

export { DeleteRawFileService };
